const SpecialOffersMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const SpecialOffers = () => import(/* webpackChunkName: "admin-module" */ './views/SpecialOffers');
const Create = () => import(/* webpackChunkName: "admin-module" */ './views/Create');
const Edit = () => import(/* webpackChunkName: "admin-module" */ './views/Edit');
const Show = () => import(/* webpackChunkName: "admin-module" */ './views/Show');

export default [
    {
        path: 'special-offers',
        components: { base: SpecialOffersMain },
        children: [
            {
                path: '',
                name: 'specialoffers',
                components: { specialoffers: SpecialOffers }
            },
            {
                path: 'create',
                name: 'specialoffers.create',
                components: { specialoffers: Create }
            },
            {
                path: ':offer_id/edit',
                name: 'specialoffers.edit',
                components: { specialoffers: Edit }
            },
            {
                path: ':offer_id/show',
                name: 'specialoffers.show',
                components: { specialoffers: Show }
            }
        ]
    },
];
